import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

const MovieDisplay = ({ movieTitle, movieFact }) => {
  return (
    <Paper sx={{ 
      p: 3, 
      mt: 3, 
      backgroundColor: 'rgba(0, 0, 0, 0.7)', 
      color: 'white' 
    }}>
      <Typography variant="h5" gutterBottom>
        Fact about "{movieTitle || 'Movie'}"
      </Typography>
      <Typography>
        {movieFact}
      </Typography>
    </Paper>
  );
};

export default MovieDisplay; 